<template>
  <aplayer :key="Playkey" :music="musicLists[bar]" controls="controls" preload="auto" :autoplay="autoplay"
    @hook:mounted="playMounted">
  </aplayer>
</template>

<script>
  import aplayer from 'vue-aplayer'
  export default {
    name: 'playMusic',
    components: {
      aplayer,
    },
    props: {
      bar: {
        default: 0
      }
    },
    watch: {
      bar: {
        handler(val) {
          this.Playkey = +new Date()
        }
      }
    },
    data() {
      return {
        Playkey: 123123,
        autoplay: false,
        musicLists: [{
            title: '送春',
            artist: '王晓慧',
            src: 'http://ceshi10.qingsongxinxi.com/music/Send spring.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/Send spring.txt'
          },
          {
            title: '萤火',
            artist: '王晓慧',
            src: 'http://ceshi10.qingsongxinxi.com/music/firefly.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/firefly.txt'
          },
          {
            title: '雨晴',
            artist: '王晓慧',
            time: '02:22',
            src: 'http://ceshi10.qingsongxinxi.com/music/rain.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/rain.txt'
          },
          {
            title: '燕歌行',
            artist: '王晓慧',
            src: 'http://ceshi10.qingsongxinxi.com/music/Chanting.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/Chanting.txt'
          },
          {
            title: '跋涉者',
            artist: '邓金晶',
            time: '04:19',
            src: 'http://ceshi10.qingsongxinxi.com/music/wader.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/wader.txt'
          },
          {
            title: '成就梦想',
            artist: '解放',
            src: 'http://ceshi10.qingsongxinxi.com/music/fulfill dream.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/fulfill dream.txt'
          },

          {
            title: '幸福就在眼前',
            artist: '程伟',
            time: '03:35',
            src: 'http://ceshi10.qingsongxinxi.com/music/happiness.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/happiness.txt'
          },
          {
            title: '心里面的思念',
            artist: '程伟',
            time: '03:44',
            src: 'http://ceshi10.qingsongxinxi.com/music/miss.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/miss.txt'
          },
          {
            title: '走过千山万水',
            artist: '程伟',
            time: '03:20',
            src: 'http://ceshi10.qingsongxinxi.com/music/through.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/through.txt'
          },
          {
            title: '真的不后悔',
            artist: '程伟',
            time: '03:25',
            src: 'http://ceshi10.qingsongxinxi.com/music/unregretful.mp3',
            lrc: 'http://ceshi10.qingsongxinxi.com/music/unregretful.txt'
          },
        ]
      }
    },
    methods: {
      playMounted() {
        this.autoplay = true
      }
    }
  }
</script>

<style scoped>
  .aplayer {
    margin: 0 360px;
  }
</style>